import { Component, Input } from '@angular/core';
import { ModalContentProps, modalContentStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-modal-content',
  templateUrl: './modal-content.component.html',
})
export class ModalContentComponent {
  @Input() css: ModalContentProps['css'];
  @Input() id = '';

  public get modalContent(): string[] {
    return [modalContentStyles({ css: this.css }).className];
  }
}
